import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../../api';
import { useFirmContext } from '../../providers/FirmProvider';

export type PriorInvoice = {
    id: string;
    date: string;
    amount: number;
    status: string;
    pdf: string;
    number: string;
};

type GetPriorInvoicesResponse = {
    invoices: PriorInvoice[];
};

async function getInvoices(firmId: string): Promise<GetPriorInvoicesResponse> {
    const { data } = await api.get(`/firms/${firmId}/subscription/v2/prior-invoices`);
    return data;
}

export function usePriorInvoices(): UseQueryResult<GetPriorInvoicesResponse, unknown> {
    const { id } = useFirmContext();
    return useQuery(['prior-invoices'], () => getInvoices(id));
}
